import { Navigate } from "react-router-dom";
import ErrorPage from "../components/errorPage/errorPage";
import NycbsCompletedLayout from "../pages/nycbsCompletedLayout/nycbsCompletedLayout";
import NycbsLayout from "../pages/nycbsLayout/nycbsLayout";
import Members from "../pages/settings/members/members";
import Profile from "../pages/settings/profile/profile";
import Security from "../pages/settings/security/security";
import Settings from "../pages/settings/settings";
import Support from "../pages/settings/support/support";

export const NycbsPharmaPaRouteConfig = [
  { index: true, element: <NycbsLayout /> },
  {
    path: "nycbs-pharma-pa-worklists",
    element: <NycbsLayout />,
  },
  {
    path: "nycbs-pharma-pa-completed",
    element: <NycbsCompletedLayout />,
  },
  {
    path: "settings",
    element: <Settings />,
    children: [
      { index: true, element: <Navigate to="profile" replace /> },
      { path: "profile", element: <Profile /> },
      { path: "security", element: <Security /> },
      { path: "members", element: <Members /> },
      { path: "support", element: <Support /> },
    ],
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
];
